import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_k6u36ypdaj: FaireCollectionEntity = {
  token: "pbc_k6u36ypdaj",
  type: "collection",
  name: "INCOMING ARRIVALS",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9fc1aa9ff24af2fbc1d5b70caf0e34006701a8d48d4a33ffabc10e3f79f92b23.jpeg",
  itemCount: 44,
  description:
    "Explore our latest arrivals, featuring this year's must-have trends. \n\nShop now with 5% off on pre-orders and in-stock items!\n\nFor styling tips or an exclusive look at new styles, check out our socials IG: @_lemonadeshoes or TIKTOK: @lemonadeshoes\n\n\n\n\n\n\n\n",
  brandToken: "b_mz3xxxsvnf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:30.117Z",
    importedBy: "entity-db-import-collections",
  },
};
